import { requests } from '@/libs/axios/axios'
import { LicenseEndpoints } from '../license-endpoints'

async function requestLicenseCancellation(body: { reason: string }, id: number) {
  return requests.post(`${LicenseEndpoints.LICENSE}/${id}/request-cancellation`, body)
}

export default requestLicenseCancellation
